export const APP_ROUTES_CONFIG = {
  AUTH: '/auth',
  AUTH_SIGN_IN: '/auth/sign-in',
  AUTH_SIGN_UP: '/auth/sign-up',
  DISCOVER: '/discover',
  LIST: '/my-list',
  TAGS: '/tags',
  SETTINGS: '/settings'
};
